<div (click)="showDateChangeAlert(field)">
  <mat-form-field
    *ngIf="field"
    appearance="outline"
    [formGroup]="group"
    [style.width]="field.matFormFieldWidth"
    (click)="picker.open()"
  >
    <input
      style="text-align: center"
      style="display: none"
      [readonly]="true"
      matInput
      [matDatepicker]="picker"
      [formControlName]="field.name"
      [min]="minDate" 
      [max]="maxDate"
    />
    <input
      style="text-align: center"
      matInput
      [placeholder]="field.label"
      [value]="
        group.controls[field.name].value
          | dateFilter
            : (field.dateConfig?.yearAndMonth ? 'MM/yyyy' : 'dd/MM/yyyy')
      "
      readonly
    />
    <mat-datepicker
      startView="multi-year"
      [touchUi]="true"
      (yearSelected)="chosenYearHandler($event)"
      (monthSelected)="chosenMonthHandler($event, picker)"
      #picker
    ></mat-datepicker>
  </mat-form-field>
  <ng-container *ngFor="let validation of field.validations">
    <div
      style="
        margin-top: -1rem;
        margin-bottom: 1rem;
        color: #f44336;
        font-size: 75%;
      "
      *ngIf="error(validation)"
    >
      {{ validation.message }}
    </div>
  </ng-container>
</div>
